import * as React from 'react';
import { useFormSlot } from '../../../../slots/forms/form-context.js';
import '../../../../slots/summaries/summary-context.js';
import '../../../../slots/summaries/types.js';

const ExpressCheckoutFormContainer = ()=>{
    const { expressCheckout  } = useFormSlot();
    if (!expressCheckout) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-checkout-form-container"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, expressCheckout));
};

export { ExpressCheckoutFormContainer };
//# sourceMappingURL=ExpressCheckoutFormContainer.js.map
